<template>
  <Layout>
    <template slot="title">{{ sectionsTitle }}</template>

    <template slot="description">
      {{ sectionsText }}
    </template>

    <VideosSearch />

    <article class="max-w-screen-3xl mx-auto flex justify-end py-8 pr-12">
      <div
        class="cursor-pointer text-secondary-500 px-2 py-1 rounded flex items-center transition duration-200 hover:bg-secondary-100"
        @click="$store.commit('videos/setShowFilter', true)"
      >
        <span class="pr-3 uppercase text-lg sm:text-2xl">
          Filtrar por Temática
        </span>
        <span class="text-xl sm:text-3xl"><BaseIcon name="stream"/></span>
      </div>
    </article>

    <div class="max-w-screen-xl mx-auto">
      <slot />
      <VideosList />
    </div>

    <transition name="fade">
      <VideosFilter v-if="showFilter" />
    </transition>
  </Layout>
</template>

<script>
import { mapState } from 'vuex'
import Layout from '@/layouts/MainLayout'
import VideosSearch from '@/components/VideosSearch'
import VideosFilter from '@/components/VideosFilter'
import VideosList from '@/components/VideosList'

export default {
  components: { Layout, VideosSearch, VideosFilter, VideosList },

  props: {
    slug: {
      type: String,
      required: false,
      default: '',
    },
  },

  computed: {
    ...mapState('sections', ['sectionsTitle', 'sectionsText']),
    ...mapState('videos', ['showFilter']),
  },

  mounted() {
    // Clear filters when open new section
    this.$store.commit('videos/clearFilters')
    this.$store.commit('videos/setShowFilter', false)
  },
}
</script>
